(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inventory-order-form"] && !Shopify.designMode) return;
  try {
    
  class InventoryOrderForm extends HTMLElement {
    #abortController = null;
    #collectionOrderCache = new Map();
    #isApplyingHashState = false;
    #sortState = { key: 'stock', direction: 'descending' };

    async connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      window.addEventListener('hashchange', this.#handleHashChange, { signal });
      this.#collectionSelect?.addEventListener('change', this.#handleCollectionChange, { signal });
      this.#searchInput?.addEventListener('input', this.#handleSearch, { signal });
      this.#sortSelect?.addEventListener('change', this.#handleSortSelect, { signal });
      this.#clearButton?.addEventListener('click', this.#handleClearSearch, { signal });
      this.#submitButton?.addEventListener('click', this.#handleSubmit, { signal });
      this.#downloadButton?.addEventListener('click', this.#handleDownloadOrder, { signal });

      for (const input of this.#quantityInputs) {
        input.addEventListener('input', this.#handleQuantityInput, { signal });
        input.addEventListener('keydown', this.#handleQuantityKeydown, { signal });
        input.addEventListener('blur', this.#normalizeQuantityInput, { signal });
      }

      this.#updateSelectionSummary();
      await this.#applyHashState();
      this.#sortRows();
      this.#updateSortButtons();
      this.#updateSortSelect();
      this.#updateVisibleRows();
      this.#clearButtonState();
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    get #searchInput() {
      return this.querySelector('[ref="searchInput"]');
    }

    get #clearButton() {
      return this.querySelector('[ref="clearButton"]');
    }

    get #collectionSelect() {
      return this.querySelector('[ref="collectionSelect"]');
    }

    get #sortSelect() {
      return this.querySelector('[ref="sortSelect"]');
    }

    get #submitButton() {
      return this.querySelector('[ref="submitButton"]');
    }

    get #downloadButton() {
      return this.querySelector('[ref="downloadButton"]');
    }

    get #downloadStatusMessage() {
      return this.querySelector('[ref="downloadStatusMessage"]');
    }

    get #selectionSummary() {
      return this.querySelector('[ref="selectionSummary"]');
    }

    get #statusMessage() {
      return this.querySelector('[ref="statusMessage"]');
    }

    get #emptyMessage() {
      return this.querySelector('[ref="emptyMessage"]');
    }

    get #rowsContainer() {
      return this.querySelector('[ref="rowsContainer"]');
    }

    get #rows() {
      return Array.from(this.querySelectorAll('[data-product-row]')).filter((row) => row instanceof HTMLElement);
    }

    get #quantityInputs() {
      return Array.from(this.querySelectorAll('[data-quantity-input]')).filter(
        (input) => input instanceof HTMLInputElement
      );
    }

    #handleSearch = () => {
      this.#updateVisibleRows();
      this.#clearButtonState();
      this.#syncHashState();
    };

    #handleHashChange = async () => {
      await this.#applyHashState();
      this.#sortRows();
      this.#updateSortButtons();
      this.#updateSortSelect();
      this.#updateVisibleRows();
      this.#clearButtonState();
    };

    #handleCollectionChange = async () => {
      const collectionHandle = this.#selectedCollectionHandle;

      if (collectionHandle) {
        this.#sortState = { key: 'collection', direction: 'ascending' };
        await this.#ensureCollectionOrder(collectionHandle);
        if (this.#selectedCollectionHandle !== collectionHandle) return;
      } else if (this.#sortState.key === 'collection') {
        this.#sortState = { key: 'stock', direction: 'descending' };
      }

      this.#sortRows();
      this.#updateSortButtons();
      this.#updateSortSelect();
      this.#updateVisibleRows();
      this.#clearButtonState();
      this.#syncHashState();
    };

    #handleClearSearch = () => {
      const searchInput = this.#searchInput;
      const collectionSelect = this.#collectionSelect;
      if (!(searchInput instanceof HTMLInputElement)) return;

      searchInput.value = '';
      if (collectionSelect instanceof HTMLSelectElement) collectionSelect.value = '';
      if (this.#sortState.key === 'collection') {
        this.#sortState = { key: 'stock', direction: 'descending' };
      }

      this.#sortRows();
      this.#updateSortButtons();
      this.#updateSortSelect();
      this.#updateVisibleRows();
      this.#clearButtonState();
      this.#syncHashState();
      searchInput.focus();
    };

    #handleSortSelect = async () => {
      const sortSelect = this.#sortSelect;
      if (!(sortSelect instanceof HTMLSelectElement)) return;

      this.#sortState = this.#sortStateFromValue(sortSelect.value, this.#selectedCollectionHandle);

      if (this.#sortState.key === 'collection') {
        await this.#ensureCollectionOrder(this.#selectedCollectionHandle);
      }

      this.#sortRows();
      this.#updateSortButtons();
      this.#updateSortSelect();
      this.#syncHashState();
    };

    #handleQuantityInput = (event) => {
      const input = event.currentTarget;
      if (!(input instanceof HTMLInputElement)) return;

      if (input.value !== '') {
        this.#clampQuantity(input);
      }

      this.#updateSelectionSummary();
    };

    #handleQuantityKeydown = async (event) => {
      if (event.key !== 'Enter') return;

      const input = event.currentTarget;
      if (!(input instanceof HTMLInputElement)) return;

      event.preventDefault();
      this.#clampQuantity(input);
      if (input.value === '') input.value = '0';

      const items = this.#selectedItems;
      if (items.length === 0) {
        this.#showStatus('Enter a quantity for at least one variant.', true);
        this.#updateSelectionSummary();
        return;
      }

      await this.#addItems(items, {
        pendingMessage: 'Adding selected items...',
        onSuccess: () => this.#resetQuantities(),
      });
    };

    #normalizeQuantityInput = (event) => {
      const input = event.currentTarget;
      if (!(input instanceof HTMLInputElement)) return;

      this.#clampQuantity(input);
      if (input.value === '') input.value = '0';
      this.#updateSelectionSummary();
    };

    #handleSubmit = async () => {
      const items = this.#selectedItems;
      if (items.length === 0) {
        this.#showStatus('Enter a quantity for at least one variant.', true);
        return;
      }

      await this.#addItems(items, {
        pendingMessage: 'Adding selected items...',
        onSuccess: () => this.#resetQuantities(),
      });
    };

    #handleDownloadOrder = async () => {
      const lines = this.#selectedOrderLines;
      if (lines.length === 0) {
        this.#showDownloadStatus('Enter a quantity before downloading.', true);
        return;
      }

      await this.#downloadOrderPdf(lines);
    };

    async #addItems(items, { pendingMessage = 'Adding items...', onSuccess = null } = {}) {
      const submitButton = this.#submitButton;
      if (submitButton instanceof HTMLButtonElement) submitButton.disabled = true;

      this.#showStatus(pendingMessage);

      try {
        const response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items }),
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          document.dispatchEvent(
            new CustomEvent('cart:error', {
              bubbles: true,
              detail: {
                sourceId: this.id,
                message: data.message,
                description: data.description,
                errors: data.errors,
              },
            })
          );
          this.#showStatus(data.message || 'Unable to add selected items.', true);
          return false;
        }

        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        const itemCount = items.reduce((sum, item) => sum + item.quantity, 0);

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: this.id,
              data: {
                source: 'inventory-order-form',
                itemCount: cart.item_count,
              },
            },
          })
        );

        if (typeof onSuccess === 'function') onSuccess();
        this.#showStatus(`${itemCount} ${itemCount === 1 ? 'item' : 'items'} added to cart.`);
        return true;
      } catch (error) {
        console.error(error);
        this.#showStatus('Something went wrong while adding selected items.', true);
        return false;
      } finally {
        this.#updateSelectionSummary();
      }
    }

    get #selectedItems() {
      return this.#selectedOrderLines.map(({ id, quantity }) => ({ id, quantity }));
    }

    get #selectedOrderLines() {
      return this.#quantityInputs
        .map((input) => {
          const id = Number(input.dataset.variantId);
          const quantity = this.#quantityValue(input);
          if (!id || quantity <= 0) return null;

          const onHand = Number.parseInt(input.dataset.inventoryQuantity || '', 10);
          const onHandValue = Number.isFinite(onHand) ? onHand : null;

          return {
            id,
            quantity,
            productTitle: input.dataset.productTitle || 'Untitled product',
            productStyle: input.dataset.productStyle || '',
            productImage: input.dataset.productImage || '',
            variantTitle: input.dataset.variantTitle || 'OS',
            onHand: onHandValue,
            remaining: onHandValue === null ? null : onHandValue - quantity,
          };
        })
        .filter(Boolean);
    }

    #quantityValue(input) {
      if (input.disabled) return 0;

      const value = Number.parseInt(input.value, 10);
      return Number.isFinite(value) && value > 0 ? value : 0;
    }

    #clampQuantity(input) {
      const value = Number.parseInt(input.value, 10);
      if (!Number.isFinite(value)) {
        input.value = '';
        return;
      }

      const min = Number.parseInt(input.min || '0', 10);
      const max = input.max === '' ? null : Number.parseInt(input.max, 10);
      let nextValue = Math.max(value, Number.isFinite(min) ? min : 0);

      if (max !== null && Number.isFinite(max)) {
        nextValue = Math.min(nextValue, max);
      }

      input.value = String(nextValue);
    }

    #updateSelectionSummary() {
      const totalQuantity = this.#selectedItems.reduce((sum, item) => sum + item.quantity, 0);
      const selectionSummary = this.#selectionSummary;
      if (selectionSummary instanceof HTMLElement) {
        selectionSummary.textContent = `${totalQuantity} ${totalQuantity === 1 ? 'item' : 'items'} selected`;
      }

      const submitButton = this.#submitButton;
      if (submitButton instanceof HTMLButtonElement) {
        submitButton.disabled = totalQuantity === 0;
      }

      const downloadButton = this.#downloadButton;
      if (downloadButton instanceof HTMLButtonElement) {
        downloadButton.disabled = totalQuantity === 0;
      }
    }

    #resetQuantities() {
      for (const input of this.#quantityInputs) {
        input.value = '0';
      }

      this.#updateSelectionSummary();
    }

    async #downloadOrderPdf(lines) {
      const generatedAt = new Date();
      this.#showDownloadStatus('Preparing PDF...');

      try {
        const groups = await this.#selectedOrderGroups(lines);
        const logoImage = await this.#pdfLogoImage;
        const pdf = this.#buildOrderPdf(groups, generatedAt, logoImage, this.#pdfHeaderDetails);
        const blob = new Blob([pdf], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const timestamp = generatedAt.toISOString().slice(0, 16).replace(/[-:T]/g, '');

        link.href = url;
        link.download = `order-request-${timestamp}.pdf`;
        document.body.append(link);
        link.click();
        link.remove();
        window.setTimeout(() => URL.revokeObjectURL(url), 1000);
        this.#showDownloadStatus('Order PDF downloaded.');
      } catch (error) {
        console.error(error);
        this.#showDownloadStatus('Unable to prepare PDF.', true);
      }
    }

    async #selectedOrderGroups(lines) {
      const groupsByProduct = new Map();

      for (const line of lines) {
        const key = [line.productTitle, line.productStyle, line.productImage].join('\u001F');
        if (!groupsByProduct.has(key)) {
          groupsByProduct.set(key, {
            productTitle: line.productTitle,
            productStyle: line.productStyle,
            productImage: line.productImage,
            image: null,
            variants: [],
          });
        }

        groupsByProduct.get(key).variants.push(line);
      }

      const groups = Array.from(groupsByProduct.values());
      const imageCache = new Map();

      await Promise.all(
        groups.map(async (group) => {
          if (!group.productImage) return;
          if (!imageCache.has(group.productImage)) {
            imageCache.set(group.productImage, this.#imageUrlToPdfImage(group.productImage));
          }
          group.image = await imageCache.get(group.productImage);
        })
      );

      return groups;
    }

    get #pdfHeaderDetails() {
      const {
        customerCompany = '',
        customerEmail = '',
        customerName = '',
        customerPhone = '',
        storeAddressLineOne = '',
        storeAddressLineTwo = '',
        storeCity = '',
        storeCountry = '',
        storeName = '',
        storeRegion = '',
        storeZip = '',
      } = this.dataset;
      const cityRegionZip = [storeCity, [storeRegion, storeZip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
      const storeLines = [storeName, storeAddressLineOne, storeAddressLineTwo, cityRegionZip, storeCountry].filter(Boolean);
      const requestedByLines = [
        customerName,
        customerCompany,
        customerEmail,
        customerPhone,
      ].filter(Boolean);

      return {
        requestedByLines: requestedByLines.length > 0 ? requestedByLines : ['Not logged in'],
        storeLines: storeLines.length > 0 ? storeLines : ['Shipping address unavailable'],
      };
    }

    get #pdfLogoImage() {
      const headerLogo = document.querySelector('.header-logo img, .logo-block__image');
      const logoUrl =
        this.dataset.storeLogo ||
        (headerLogo instanceof HTMLImageElement ? headerLogo.currentSrc || headerLogo.src : '');
      return logoUrl ? this.#imageUrlToPdfImage(logoUrl, 280) : Promise.resolve(null);
    }

    async #imageUrlToPdfImage(imageUrl, maxSize = 96) {
      const src = this.#absoluteImageUrl(imageUrl);
      if (!src) return null;

      return new Promise((resolve) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';

        image.onload = () => {
          try {
            const sourceWidth = image.naturalWidth || image.width;
            const sourceHeight = image.naturalHeight || image.height;
            const scale = Math.min(maxSize / sourceWidth, maxSize / sourceHeight, 1);
            const width = Math.max(1, Math.round(sourceWidth * scale));
            const height = Math.max(1, Math.round(sourceHeight * scale));
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            if (!context) {
              resolve(null);
              return;
            }

            canvas.width = width;
            canvas.height = height;
            context.fillStyle = '#ffffff';
            context.fillRect(0, 0, width, height);
            context.drawImage(image, 0, 0, width, height);

            const base64 = canvas.toDataURL('image/jpeg', 0.86).split(',')[1];
            const binary = window.atob(base64);
            let hex = '';
            for (let index = 0; index < binary.length; index += 1) {
              hex += binary.charCodeAt(index).toString(16).padStart(2, '0');
            }

            resolve({ width, height, hex, refName: '' });
          } catch (error) {
            console.error(error);
            resolve(null);
          }
        };

        image.onerror = () => resolve(null);
        image.src = src;
      });
    }

    #absoluteImageUrl(imageUrl) {
      if (!imageUrl) return '';
      if (imageUrl.startsWith('//')) return `${window.location.protocol}${imageUrl}`;
      if (imageUrl.startsWith('/')) return `${window.location.origin}${imageUrl}`;
      return imageUrl;
    }

    #buildOrderPdf(groups, generatedAt, logoImage = null, headerDetails = {}) {
      const pageWidth = 612;
      const pageHeight = 792;
      const margin = 36;
      const bottomMargin = 42;
      const rowGap = 8;
      const productWidth = 160;
      const totalColumnWidth = 44;
      const totalColumnX = pageWidth - margin - totalColumnWidth;
      const variantX = margin + productWidth + 16;
      const variantWidth = totalColumnX - variantX - 16;
      const cellWidth = 66;
      const cellHeight = 56;
      const cellGap = 6;
      const cellsPerRow = Math.max(1, Math.floor((variantWidth + cellGap) / (cellWidth + cellGap)));
      const images = [];
      const pages = [];
      let commands = [];
      let y = 0;
      let pageNumber = 0;

      for (const image of [logoImage, ...groups.map((group) => group.image)].filter(Boolean)) {
        if (images.includes(image)) continue;
        image.refName = `Im${images.length + 1}`;
        images.push(image);
      }

      const allVariants = groups.flatMap((group) => group.variants);
      const orderedTotal = allVariants.reduce((sum, line) => sum + line.quantity, 0);

      const drawText = (text, x, textY, size = 10, font = 'F1') => {
        commands.push(`BT /${font} ${size} Tf 1 0 0 1 ${x} ${textY} Tm (${this.#pdfText(text)}) Tj ET`);
      };

      const drawCenteredText = (text, x, textY, width, size = 10, font = 'F1') => {
        const safeText = this.#plainPdfText(text);
        const estimatedWidth = safeText.length * size * 0.52;
        drawText(safeText, x + Math.max(0, (width - estimatedWidth) / 2), textY, size, font);
      };

      const drawRightText = (text, x, textY, size = 10, font = 'F1') => {
        const safeText = this.#plainPdfText(text);
        const estimatedWidth = safeText.length * size * 0.52;
        drawText(safeText, x - estimatedWidth, textY, size, font);
      };

      const drawLine = (x1, y1, x2, y2) => {
        commands.push(`0.82 G 0.5 w ${x1} ${y1} m ${x2} ${y2} l S 0 G`);
      };

      const drawInfoBlock = (label, lines, x, topY, maxChars) => {
        let blockY = topY;
        if (label) {
          drawText(label, x, blockY, 7.5, 'F2');
          blockY -= 10;
        }

        for (const line of lines.slice(0, 5)) {
          for (const wrappedLine of this.#wrapPdfText(line, maxChars, 2)) {
            drawText(wrappedLine, x, blockY, 7.5);
            blockY -= 9;
          }
        }

        return topY - blockY;
      };

      const drawStrokeRect = (x, topY, width, height, shade = 0.9) => {
        commands.push(`${shade} G 0.5 w ${x} ${topY - height} ${width} ${height} re S 0 G`);
      };

      const drawFilledRect = (x, topY, width, height, color = '0.96 0.96 0.96') => {
        commands.push(`${color} rg ${x} ${topY - height} ${width} ${height} re f 0 g`);
      };

      const drawImage = (image, x, topY, width, height) => {
        if (!image?.refName) {
          drawStrokeRect(x, topY, width, height, 0.88);
          return;
        }

        const scale = Math.min(width / image.width, height / image.height);
        const drawWidth = image.width * scale;
        const drawHeight = image.height * scale;
        const drawX = x + (width - drawWidth) / 2;
        const drawY = topY - height + (height - drawHeight) / 2;
        commands.push(`q ${drawWidth} 0 0 ${drawHeight} ${drawX} ${drawY} cm /${image.refName} Do Q`);
      };

      const drawDot = (x, dotY, color) => {
        const radius = 3;
        const control = radius * 0.5522847498;
        const left = x - radius;
        const right = x + radius;
        const top = dotY + radius;
        const bottom = dotY - radius;

        commands.push(
          `${color} rg ${x} ${top} m ${x + control} ${top} ${right} ${dotY + control} ${right} ${dotY} c ${right} ${dotY - control} ${x + control} ${bottom} ${x} ${bottom} c ${x - control} ${bottom} ${left} ${dotY - control} ${left} ${dotY} c ${left} ${dotY + control} ${x - control} ${top} ${x} ${top} c f 0 g`
        );
      };

      const drawVariantCell = (variant, x, topY) => {
        const stock = variant.onHand === null ? '-' : variant.onHand;
        const dotColor = variant.onHand === null || variant.onHand > 20 ? '0.294 0.620 0.357' : variant.onHand > 0 ? '0.788 0.592 0.149' : '0.788 0.278 0.216';
        const cellBackground = variant.onHand === 0 ? '0.975 0.975 0.975' : '1 1 1';
        const stockText = `On hand ${stock}`;
        const stockTextSize = 6.8;
        const stockLineX = x + 8;

        drawFilledRect(x, topY, cellWidth, cellHeight, cellBackground);
        drawStrokeRect(x, topY, cellWidth, cellHeight, 0.88);
        drawFilledRect(x + 3, topY - 3, cellWidth - 6, 15, '0.94 0.94 0.94');
        drawCenteredText(this.#truncatePdfText(variant.variantTitle || 'OS', 9), x + 3, topY - 14, cellWidth - 6, 9, 'F2');

        drawCenteredText(String(variant.quantity), x + 3, topY - 35, cellWidth - 6, 15, 'F2');

        drawDot(stockLineX, topY - 47, dotColor);
        drawText(stockText, stockLineX + 10, topY - 49, stockTextSize);
      };

      const drawHeader = () => {
        pageNumber += 1;
        commands = [];
        y = pageHeight - margin;
        const hasLogo = Boolean(logoImage?.refName);
        const titleY = hasLogo ? y - 54 : y - 30;

        if (hasLogo) {
          drawImage(logoImage, margin, y + 4, 150, 28);
        } else {
          drawText('Paradigm / Saddle Point', margin, y, 10, 'F2');
        }
        drawText('Order Request', margin, titleY, 20, 'F2');
        drawText(`Generated ${this.#formatPdfDate(generatedAt)}`, margin, titleY - 18, 9);

        if (pageNumber === 1) {
          const detailsTopY = titleY - 38;
          const storeBlockHeight = drawInfoBlock('', headerDetails.storeLines || [], margin, detailsTopY, 32);
          const requestedByBlockHeight = drawInfoBlock(
            'Requested by',
            headerDetails.requestedByLines || [],
            margin + 290,
            detailsTopY,
            28
          );

          y = detailsTopY - Math.max(storeBlockHeight, requestedByBlockHeight) - 18;
        } else {
          y -= hasLogo ? 98 : 74;
        }

        drawLine(margin, y + 10, pageWidth - margin, y + 10);
        drawText('Product', margin, y - 5, 9, 'F2');
        drawRightText('Total', pageWidth - margin, y - 5, 9, 'F2');
        drawLine(margin, y - 15, pageWidth - margin, y - 15);
        y -= 34;
      };

      const finishPage = () => {
        if (commands.length > 0) pages.push(commands.join('\n'));
      };

      drawHeader();

      for (const group of groups) {
        const groupTotal = group.variants.reduce((sum, variant) => sum + variant.quantity, 0);
        const variantRows = Math.ceil(group.variants.length / cellsPerRow);
        const rowHeight = Math.max(72, variantRows * (cellHeight + cellGap) + 12);

        if (y - rowHeight < bottomMargin) {
          finishPage();
          drawHeader();
        }

        drawImage(group.image, margin, y - 7, 50, 50);
        this.#wrapPdfText(group.productTitle, 18, 2).forEach((text, index) => {
          drawText(text, margin + 62, y - 20 - index * 11, 9, index === 0 ? 'F2' : 'F1');
        });
        if (group.productStyle) {
          this.#wrapPdfText(group.productStyle, 19, 2).forEach((text, index) => {
            drawText(text, margin + 62, y - 44 - index * 10, 8);
          });
        }

        group.variants.forEach((variant, index) => {
          const row = Math.floor(index / cellsPerRow);
          const column = index % cellsPerRow;
          drawVariantCell(variant, variantX + column * (cellWidth + cellGap), y - 7 - row * (cellHeight + cellGap));
        });

        drawRightText(String(groupTotal), pageWidth - margin, y - 34, 11, 'F2');

        y -= rowHeight + rowGap;
        drawLine(margin, y + 5, pageWidth - margin, y + 5);
      }

      if (y - 34 < bottomMargin) {
        finishPage();
        drawHeader();
      }

      drawLine(totalColumnX, y - 2, pageWidth - margin, y - 2);
      drawRightText('Total', totalColumnX + 18, y - 22, 10, 'F2');
      drawRightText(String(orderedTotal), pageWidth - margin, y - 22, 12, 'F2');

      finishPage();
      return this.#createPdfDocument(pages, pageWidth, pageHeight, images);
    }

    #createPdfDocument(pageContents, pageWidth, pageHeight, images = []) {
      const objects = [];
      const fontOneObjectNumber = 3 + pageContents.length * 2;
      const fontTwoObjectNumber = fontOneObjectNumber + 1;
      const firstImageObjectNumber = fontTwoObjectNumber + 1;
      const pageObjectNumbers = pageContents.map((_, index) => 3 + index * 2);
      const imageResources = images
        .map((image, index) => `/${image.refName} ${firstImageObjectNumber + index} 0 R`)
        .join(' ');

      objects.push('<< /Type /Catalog /Pages 2 0 R >>');
      objects.push(`<< /Type /Pages /Kids [${pageObjectNumbers.map((number) => `${number} 0 R`).join(' ')}] /Count ${pageContents.length} >>`);

      pageContents.forEach((content, index) => {
        const pageObjectNumber = 3 + index * 2;
        const contentObjectNumber = pageObjectNumber + 1;

        objects.push(
          `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${pageWidth} ${pageHeight}] /Resources << /Font << /F1 ${fontOneObjectNumber} 0 R /F2 ${fontTwoObjectNumber} 0 R >> /XObject << ${imageResources} >> >> /Contents ${contentObjectNumber} 0 R >>`
        );
        objects.push(`<< /Length ${content.length} >>\nstream\n${content}\nendstream`);
      });

      objects.push('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>');
      objects.push('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold >>');

      for (const image of images) {
        objects.push(
          `<< /Type /XObject /Subtype /Image /Width ${image.width} /Height ${image.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter [/ASCIIHexDecode /DCTDecode] /Length ${image.hex.length + 1} >>\nstream\n${image.hex}>\nendstream`
        );
      }

      let pdf = '%PDF-1.4\n';
      const offsets = [0];

      objects.forEach((body, index) => {
        offsets[index + 1] = pdf.length;
        pdf += `${index + 1} 0 obj\n${body}\nendobj\n`;
      });

      const xrefOffset = pdf.length;
      pdf += `xref\n0 ${objects.length + 1}\n0000000000 65535 f \n`;
      for (let index = 1; index <= objects.length; index += 1) {
        pdf += `${String(offsets[index]).padStart(10, '0')} 00000 n \n`;
      }
      pdf += `trailer\n<< /Size ${objects.length + 1} /Root 1 0 R >>\nstartxref\n${xrefOffset}\n%%EOF`;

      return pdf;
    }

    #formatPdfDate(date) {
      return new Intl.DateTimeFormat(undefined, {
        dateStyle: 'medium',
        timeStyle: 'short',
      }).format(date);
    }

    #wrapPdfText(value, maxLength, maxLines) {
      const words = this.#plainPdfText(value).split(/\s+/).filter(Boolean);
      const lines = [];
      let currentLine = '';

      for (const word of words) {
        const nextLine = currentLine ? `${currentLine} ${word}` : word;
        if (nextLine.length <= maxLength) {
          currentLine = nextLine;
        } else {
          if (currentLine) lines.push(currentLine);
          currentLine = word;
        }

        if (lines.length === maxLines) break;
      }

      if (currentLine && lines.length < maxLines) lines.push(currentLine);
      if (lines.length === 0) lines.push('-');

      const remainingWords = words.join(' ');
      const joinedLines = lines.join(' ');
      if (remainingWords.length > joinedLines.length && lines.length > 0) {
        lines[lines.length - 1] = `${lines[lines.length - 1].slice(0, Math.max(0, maxLength - 3))}...`;
      }

      return lines;
    }

    #truncatePdfText(value, maxLength) {
      const text = this.#plainPdfText(value);
      return text.length > maxLength ? `${text.slice(0, Math.max(0, maxLength - 3))}...` : text;
    }

    #pdfText(value) {
      return this.#plainPdfText(value).replace(/\\/g, '\\\\').replace(/\(/g, '\\(').replace(/\)/g, '\\)');
    }

    #plainPdfText(value) {
      return String(value ?? '')
        .normalize('NFKD')
        .replace(/[^\x20-\x7E]/g, '')
        .trim();
    }

    get #selectedCollectionHandle() {
      const collectionSelect = this.#collectionSelect;
      return collectionSelect instanceof HTMLSelectElement ? collectionSelect.value.trim().toLowerCase() : '';
    }

    async #applyHashState() {
      const params = this.#hashParams;
      const collectionSelect = this.#collectionSelect;
      const searchInput = this.#searchInput;

      this.#isApplyingHashState = true;

      try {
        if (collectionSelect instanceof HTMLSelectElement) {
          const collection = (params.get('collection') || '').trim().toLowerCase();
          const hasCollection = Array.from(collectionSelect.options).some((option) => option.value === collection);
          collectionSelect.value = hasCollection ? collection : '';
        }

        if (searchInput instanceof HTMLInputElement) {
          searchInput.value = params.get('q') || '';
        }

        const collectionHandle = this.#selectedCollectionHandle;
        const sortValue = params.get('sort') || (collectionHandle ? 'collection-asc' : 'stock-desc');
        this.#sortState = this.#sortStateFromValue(sortValue, collectionHandle);

        if (this.#sortState.key === 'collection') {
          await this.#ensureCollectionOrder(collectionHandle);
        }
      } finally {
        this.#isApplyingHashState = false;
      }

      this.#syncHashState();
    }

    get #hashParams() {
      const hash = window.location.hash || '';
      if (!hash.startsWith('#!')) return new URLSearchParams();

      return new URLSearchParams(hash.slice(2));
    }

    #sortStateFromValue(value, collectionHandle) {
      const [rawKey, rawDirection] = String(value || '').split('-');
      const key = ['collection', 'stock', 'title'].includes(rawKey) ? rawKey : 'stock';
      const direction = rawDirection === 'asc' ? 'ascending' : 'descending';

      if (key === 'collection' && !collectionHandle) {
        return { key: 'stock', direction: 'descending' };
      }

      if (key === 'collection') return { key, direction: 'ascending' };
      return { key, direction };
    }

    #syncHashState() {
      if (this.#isApplyingHashState) return;

      const searchInput = this.#searchInput;
      const params = new URLSearchParams();
      const collectionHandle = this.#selectedCollectionHandle;
      const query = searchInput instanceof HTMLInputElement ? searchInput.value.trim() : '';
      const sortValue = this.#sortValue;

      if (collectionHandle) params.set('collection', collectionHandle);
      if (query) params.set('q', query);
      if (sortValue !== 'stock-desc' || collectionHandle) params.set('sort', sortValue);

      const nextHash = params.toString() ? `#!${params.toString()}` : '';
      const nextUrl = `${window.location.pathname}${window.location.search}${nextHash}`;

      window.history.replaceState(null, '', nextUrl);
    }

    get #sortValue() {
      const direction = this.#sortState.direction === 'ascending' ? 'asc' : 'desc';
      return `${this.#sortState.key}-${direction}`;
    }

    async #ensureCollectionOrder(collectionHandle) {
      if (!collectionHandle || this.#collectionOrderCache.has(collectionHandle)) return;

      const productHandles = [];

      try {
        for (let page = 1; page <= 10; page += 1) {
          const response = await fetch(this.#collectionProductsUrl(collectionHandle, page), {
            headers: { Accept: 'application/json' },
            signal: this.#abortController?.signal,
          });

          if (!response.ok) throw new Error(`Unable to load collection order for ${collectionHandle}`);

          const data = await response.json();
          const products = Array.isArray(data.products) ? data.products : [];

          for (const product of products) {
            if (typeof product.handle === 'string') productHandles.push(product.handle.toLowerCase());
          }

          if (products.length < 250) break;
        }
      } catch (error) {
        if (error.name !== 'AbortError') console.error(error);
      }

      this.#collectionOrderCache.set(
        collectionHandle,
        new Map(productHandles.map((handle, index) => [handle, index]))
      );
    }

    #collectionProductsUrl(collectionHandle, page) {
      const root = window.Shopify?.routes?.root || '/';
      const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
      return `${normalizedRoot}collections/${encodeURIComponent(collectionHandle)}/products.json?limit=250&page=${page}`;
    }

    #updateVisibleRows() {
      const searchInput = this.#searchInput;
      const collectionSelect = this.#collectionSelect;
      const query = searchInput instanceof HTMLInputElement ? searchInput.value.trim().toLowerCase() : '';
      const collection =
        collectionSelect instanceof HTMLSelectElement ? collectionSelect.value.trim().toLowerCase() : '';
      let visibleCount = 0;

      for (const row of this.#rows) {
        const rowCollections = (row.dataset.collections || '').split(/\s+/);
        const matchesCollection = collection === '' || rowCollections.includes(collection);
        const matchesSearch = query === '' || (row.dataset.search || '').includes(query);
        const matches = matchesCollection && matchesSearch;
        row.hidden = !matches;
        if (matches) visibleCount += 1;
      }

      const emptyMessage = this.#emptyMessage;
      if (emptyMessage instanceof HTMLElement) {
        emptyMessage.hidden = visibleCount > 0;
      }
    }

    #clearButtonState() {
      const searchInput = this.#searchInput;
      const collectionSelect = this.#collectionSelect;
      const clearButton = this.#clearButton;
      if (!(searchInput instanceof HTMLInputElement) || !(clearButton instanceof HTMLButtonElement)) return;

      const hasCollection = collectionSelect instanceof HTMLSelectElement && collectionSelect.value !== '';
      const hasFilters = searchInput.value.trim() !== '' || hasCollection;
      clearButton.hidden = !hasFilters;
      clearButton.disabled = !hasFilters;
    }

    #sortRows() {
      const rowsContainer = this.#rowsContainer;
      if (!(rowsContainer instanceof HTMLElement)) return;

      const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
      const { key, direction } = this.#sortState;
      const multiplier = direction === 'ascending' ? 1 : -1;
      const rows = this.#rows;
      const collectionOrder =
        key === 'collection' ? this.#collectionOrderCache.get(this.#selectedCollectionHandle) : null;

      rows.sort((a, b) => {
        if (key === 'collection') {
          const aValue = collectionOrder?.get(a.dataset.handle || '') ?? Number.MAX_SAFE_INTEGER;
          const bValue = collectionOrder?.get(b.dataset.handle || '') ?? Number.MAX_SAFE_INTEGER;

          if (aValue !== bValue) return (aValue - bValue) * multiplier;

          return collator.compare(a.dataset.title || '', b.dataset.title || '');
        }

        if (key === 'stock') {
          const aValue = Number.parseInt(a.dataset.stock || '0', 10);
          const bValue = Number.parseInt(b.dataset.stock || '0', 10);
          return (aValue - bValue) * multiplier;
        }

        return collator.compare(a.dataset.title || '', b.dataset.title || '') * multiplier;
      });

      for (const row of rows) {
        rowsContainer.append(row);
      }
    }

    #updateSortButtons() {
    }

    #updateSortSelect() {
      const sortSelect = this.#sortSelect;
      if (!(sortSelect instanceof HTMLSelectElement)) return;

      sortSelect.value = this.#sortValue;
    }

    #showStatus(message, isError = false) {
      const statusMessage = this.#statusMessage;
      if (!(statusMessage instanceof HTMLElement)) return;

      statusMessage.textContent = message;
      statusMessage.dataset.state = isError ? 'error' : 'success';
    }

    #showDownloadStatus(message, isError = false) {
      const statusMessage = this.#downloadStatusMessage;
      if (!(statusMessage instanceof HTMLElement)) return;

      statusMessage.textContent = message;
      statusMessage.dataset.state = isError ? 'error' : 'success';
    }
  }

  if (!customElements.get('inventory-order-form')) {
    customElements.define('inventory-order-form', InventoryOrderForm);
  }

  } catch(e) { console.error(e); }
})();
})();
